import { useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { displayName } from "../lib/anagConfig";
import { Input } from "./ui/input";
import { Loader2 } from "lucide-react";

// Input predittivo alimentato dalle anagrafiche esistenti dello studio.
export default function AnagAutocomplete({ atype, value, onChange, testId, placeholder }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const boxRef = useRef(null);
  const timer = useRef(null);
  const skip = useRef(false);

  useEffect(() => {
    if (skip.current) { skip.current = false; return; }
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/anagrafiche/${atype}?q=${encodeURIComponent(value || "")}`);
        setItems(data.slice(0, 12));
        setOpen(true);
      } catch (e) { setItems([]); }
      finally { setLoading(false); }
    }, 220);
    return () => timer.current && clearTimeout(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, atype]);

  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const choose = (rec) => { skip.current = true; onChange(displayName(rec)); setOpen(false); };

  return (
    <div className="relative" ref={boxRef}>
      <Input value={value || ""} onChange={(e) => onChange(e.target.value)} onFocus={() => items.length && setOpen(true)}
        placeholder={placeholder} data-testid={testId} autoComplete="off" className="bg-slate-900/60 border-slate-700" />
      {loading && <Loader2 className="absolute right-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 animate-spin text-slate-500" />}
      {open && items.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-52 overflow-y-auto rounded-lg border border-slate-700 bg-[#0d111a] shadow-xl">
          {items.map((r) => (
            <button type="button" key={r.id} onMouseDown={(e) => { e.preventDefault(); choose(r); }}
              className="w-full text-left px-3 py-2 text-sm text-slate-200 hover:bg-slate-800/70">
              {displayName(r)}{r.comune ? <span className="text-slate-500"> · {r.comune}</span> : null}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
